import React from 'react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import moment from 'moment';

import { withTheme } from '@material-ui/core/styles';

import { getFormat, twoDigits } from 'lib/commonLib';
import { dailyRoasGraph } from 'lib/api/time';

import CurrentStatus from 'components/atoms/CurrentStatus';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import ContentsWrap from 'components/molecules/ContentsWrap';
import SwitchingArea from 'components/organisms/SwitchingArea';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';
import numeral from 'numeral';

const graphList = [
  {
    title: i18next.t('전체'),
    data: { bar: ['SESSION_ROAS'], line: ['TRGT_ROAS'] },
    yAxisData: {
      left: {
        TRGT_ROAS: true,
      },
      right: {},
    },
    referenceLine: {
      SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
      TRGT_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
      TRGT_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('웹 전체'),
    data: { bar: ['WEB_SESSION_ROAS'], line: ['WEB_TRGT_ROAS'] },
    yAxisData: {
      left: {
        WEB_SESSION_ROAS: true,
      },
      right: {},
    },
    referenceLine: {
      WEB_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
      WEB_TRGT_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      WEB_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
      WEB_TRGT_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('모바일 전체'),
    data: { bar: ['MOBILE_SESSION_ROAS'], line: ['MOBILE_TRGT_ROAS'] },
    yAxisData: {
      left: { MOBILE_SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      MOBILE_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
      MOBILE_TRGT_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      MOBILE_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
      MOBILE_TRGT_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('배너 전체'),
    data: { bar: ['B_SESSION_ROAS'], line: ['B_TRGT_ROAS'] },
    yAxisData: {
      left: {
        B_SESSION_ROAS: true,
      },
      right: {},
    },
    referenceLine: {
      B_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
      B_TRGT_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      B_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
      B_TRGT_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('배너 웹 전체'),
    data: { bar: ['B_WEB_SESSION_ROAS'], line: ['B_WEB_TRGT_ROAS'] },
    yAxisData: {
      left: { B_WEB_SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      B_WEB_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
      B_WEB_TRGT_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      B_WEB_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
      B_WEB_TRGT_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('배너 모바일 전체'),
    data: { bar: ['B_MOBILE_SESSION_ROAS'], line: ['B_MOBILE_TRGT_ROAS'] },
    yAxisData: {
      left: {
        B_MOBILE_SESSION_ROAS: true,
      },
      right: {},
    },
    referenceLine: {
      B_MOBILE_TRGT_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
      B_MOBILE_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      B_MOBILE_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
      B_MOBILE_TRGT_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('아이커버 전체'),
    data: { bar: ['I_SESSION_ROAS'], line: ['I_TRGT_ROAS'] },
    yAxisData: {
      left: { I_SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      I_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
      I_TRGT_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      I_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
      I_TRGT_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('아이커버 웹 전체'),
    data: { bar: ['I_WEB_SESSION_ROAS'], line: ['I_WEB_TRGT_ROAS'] },
    yAxisData: {
      left: {
        I_WEB_SESSION_ROAS: true,
      },
      right: {},
    },
    referenceLine: {
      I_WEB_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
      I_WEB_TRGT_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      I_WEB_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
      I_WEB_TRGT_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('아이커버 모바일 전체'),
    data: { bar: ['I_MOBILE_SESSION_ROAS'], line: ['I_MOBILE_TRGT_ROAS'] },
    yAxisData: {
      left: { I_MOBILE_SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      I_MOBILE_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
      I_MOBILE_TRGT_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      I_MOBILE_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
      I_MOBILE_TRGT_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('상품타게팅 전체'),
    data: { bar: ['PRDT_TRGT_SESSION_ROAS'] },
    yAxisData: {
      left: {
        PRDT_TRGT_SESSION_ROAS: true,
      },
      right: {},
    },
    referenceLine: {
      PRDT_TRGT_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      PRDT_TRGT_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('상품타게팅 웹 전체'),
    data: { bar: ['PRDT_TRGT_WEB_SESSION_ROAS'] },
    yAxisData: {
      left: { PRDT_TRGT_WEB_SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      PRDT_TRGT_WEB_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      PRDT_TRGT_WEB_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('상품타게팅 모바일 전체'),
    data: { bar: ['PRDT_TRGT_MOBILE_SESSION_ROAS'] },
    yAxisData: {
      left: {
        PRDT_TRGT_MOBILE_SESSION_ROAS: true,
      },
      right: {},
    },
    referenceLine: {
      PRDT_TRGT_MOBILE_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      PRDT_TRGT_MOBILE_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('해비쇼퍼 전체'),
    data: { bar: ['CW_SESSION_ROAS'] },
    yAxisData: {
      left: { CW_SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      CW_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      CW_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('해비쇼퍼 웹 전체'),
    data: { bar: ['CW_WEB_SESSION_ROAS'] },
    yAxisData: {
      left: {
        CW_WEB_SESSION_ROAS: true,
      },
      right: {},
    },
    referenceLine: {
      CW_WEB_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      CW_WEB_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('해비쇼퍼 모바일 전체'),
    data: { bar: ['CW_MOBILE_SESSION_ROAS'] },
    yAxisData: {
      left: { CW_MOBILE_SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      CW_MOBILE_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      CW_MOBILE_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('본상품 전체'),
    data: { bar: ['SR_SESSION_ROAS'] },
    yAxisData: {
      left: {
        SR_SESSION_ROAS: true,
      },
      right: {},
    },
    referenceLine: {
      SR_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      SR_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('본상품 웹 전체'),
    data: { bar: ['SR_WEB_SESSION_ROAS'] },
    yAxisData: {
      left: { SR_WEB_SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      SR_WEB_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      SR_WEB_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('본상품 모바일 전체'),
    data: { bar: ['SR_MOBILE_SESSION_ROAS'] },
    yAxisData: {
      left: {
        SR_MOBILE_SESSION_ROAS: true,
      },
      right: {},
    },
    referenceLine: {
      SR_MOBILE_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
    customizeData: {
      SR_MOBILE_SESSION_ROAS: {
        tooltipFormat: '0.0',
        isPercent: true,
      },
    },
  },
];

class AllRoasStatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      graphComponent: {},
      infoMessage: '',
      loading: false,
      error: false,
    };
  }

  getData = () => {
    const { params, locale, t } = this.props;
    const { sDate, eDate } = params;
    const format = getFormat(locale);
    this.setState({
      ...this.state,
      loading: true,
      error: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });
    dailyRoasGraph(params)
      .then((response) => {
        const { data } = response.data;

        this.setState({
          ...this.state,
          primitiveData: data,
          loading: false,
          error: false,
        });

        for (let i = 0; i <= 17; i++) {
          this.setGraphData(graphList[i], i)();
        }
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          loading: false,
          error: true,
        });
      });
  };
  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    const { t, theme } = this.props;
    const dateObj = moment(originalDate, 'YYYYMMDD');
    const month = twoDigits(dateObj.month() + 1);
    const date = dateObj.date();
    const day = dateObj.day();
    let color = '';

    if (day === 0) {
      color = theme.palette.common.red;
    } else if (day === 6) {
      color = theme.palette.common.blue;
    }

    return onlyDay ? (
      `${twoDigits(date)}${t('일')}`
    ) : (
      <span style={{ color }}>{`${t(month + '월')} ${twoDigits(date)}${t(
        '일'
      )}`}</span>
    );
  };

  xAxisTick = (tickProps) => {
    const { theme } = this.props;
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const dateObj = moment(value, 'YYYYMMDD');
    const day = dateObj.day();

    const dayStr = this.makeLabel(true)(value);
    let fill = '';
    //Sunday as 0 and Saturday as 6.
    if (day === 0) {
      fill = theme.palette.common.red;
    } else if (day === 6) {
      fill = theme.palette.common.blue;
    }
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={-5} dy={16} fill={fill} textAnchor="middle">
          {dayStr}
        </text>
      </g>
    );
  };

  /**
   * 버튼 클릭하여 그래프 데이터 변경
   */
  setGraphData =
    (
      {
        title,
        data,
        yAxisData,
        customizeData: customize,
        isPercent = false,
        referenceLine,
      },
      index
    ) =>
    () => {
      const { primitiveData } = this.state;

      if (typeof data !== 'undefined') {
        const { bar, line } = data;
        const dataKeys = {};
        const keyLabel = {};
        const tempGraphData = {};
        const graphData = [];
        let customizeData = {};
        let referenceData = {};
        const stackId = [];

        if (typeof bar !== 'undefined') {
          dataKeys['bar'] = bar;
        }

        if (typeof line !== 'undefined') {
          dataKeys['line'] = line;
        }

        if (typeof customize !== 'undefined') {
          customizeData = customize;
        }

        for (let kind in data) {
          if (data.hasOwnProperty(kind)) {
            const keys = data[kind];
            for (let i = 0; i < keys.length; i++) {
              const curKey = keys[i];
              if (kind === 'bar') {
                stackId.push(curKey);
              }

              keyLabel[curKey] = primitiveData[curKey].title;
              tempGraphData[curKey] = primitiveData[curKey].data;
            }
          }
        }

        // graph data 담는 곳
        for (let key in tempGraphData) {
          if (tempGraphData.hasOwnProperty(key)) {
            // 평균 값 선 넣기 위해
            let average = false;
            let sum = 0;
            let count = 0;
            if (typeof referenceLine[key] !== 'undefined') {
              if (referenceLine[key].type === 'average') {
                average = true;
              }
            }

            for (let i = 0; i < tempGraphData[key].length; i++) {
              const curGraphData = tempGraphData[key][i];
              let { name, val } = curGraphData;
              if (
                typeof customize !== 'undefined' &&
                typeof customize[key] !== 'undefined'
              ) {
                if (customize[key].isPercent) {
                  val *= 100;
                }
              }
              // 평균값 구하기
              if (average) {
                sum += Number(val);
                count++;
              }

              graphData[i] = {
                ...graphData[i],
                name,
                [key]: val,
              };
            }

            if (average) {
              const { label, color, visibleValue = false } = referenceLine[key];
              const y = sum / count;

              referenceData[key] = {
                y,
                label: visibleValue
                  ? `${label}(${numeral(y).format('0,00')})`
                  : label,
                color: color,
              };
            }
          }
        }

        const result = (
          <MultiplexChart
            xInterval={6}
            xAxisTick={this.xAxisTick}
            makeLabel={this.makeLabel(false)}
            data={graphData}
            dataKeys={dataKeys}
            customizeData={customizeData}
            keyLabel={keyLabel}
            stackId={stackId.length !== 0 ? stackId.join('$') : null}
            yAxisData={yAxisData}
            legend
            title={title}
            isPercent={isPercent}
            key={title}
            referenceLine={referenceData}
          />
        );

        const { graphComponent } = this.state;
        graphComponent[index] = result;

        this.setState({
          ...this.state,
          graphComponent: graphComponent,
        });
      }
    };

  // const isLoading = this.state.list === null && this.state.error !== true;
  render() {
    const { handleRefesh } = this;
    const { infoMessage, graphComponent, loading, error } = this.state;

    const graphIndexs = [
      '전체',
      '웹 전체',
      '모바일 전체',
      '배너 전체',
      '배너 웹 전체',
      '배너 모바일 전체',
      '아이커버 전체',
      '아이커버 웹 전체',
      '아이커버 모바일 전체',
      '상품타게팅 전체',
      '상품타게팅 웹 전체',
      '상품타게팅 모바일 전체',
      '해비쇼퍼 전체',
      '해비쇼퍼 웹 전체',
      '해비쇼퍼 모바일 전체',
      '본상품 전체',
      '본상품 웹 전체',
      '본상품 모바일 전체',
    ];

    return (
      <>
        {graphIndexs.map((value, index) => {
          return (
            <SwitchingArea
              key={index}
              title={
                <>
                  <InfoTitleArea
                    title={value}
                    tooltipTitle={infoMessage}
                    iconType="fainfoCircle"
                    iconColor="graph"
                  />
                </>
              }
              handleRefesh={handleRefesh}
            >
              {loading || error ? (
                <CurrentStatus type={loading ? 'loading' : error && 'error'} />
              ) : (
                <ContentsWrap contentsCount={1}>
                  {typeof graphComponent[index] !== 'undefined' &&
                    graphComponent[index]}
                </ContentsWrap>
              )}
            </SwitchingArea>
          );
        })}
      </>
    );
  }
}

export default withTranslation()(
  connect(
    ({ locale }) => ({
      locale: locale.locale,
    }),
    null
  )(withTheme(AllRoasStatisticsGraph))
);
